import React, { Component,Fragment } from "react";
import { translate } from "../Services/translation";
import moment from "moment";
import { SingleDatePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

class ERPDatePicker extends Component {
  constructor(props) {
    super(props);
    moment.locale(window.__litium.constants.currentLocale);
    this.localeFormat = moment().locale(window.__litium.constants.currentLocale).creationData().locale._longDateFormat.L;
    this.currentSelectedDate = props.selecteddate;
    // let defaultValue = new Date(),
    //   minDate = moment("0001-01-01"),
    //   defaultDate = moment(defaultValue).isAfter(minDate) ? moment(defaultValue).locale(window.__litium.constants.currentLocale) : null;
    this.state = {
      focused: false,      
      date:this.currentSelectedDate!=''? moment(this.currentSelectedDate,this.localeFormat):null
    };
  }

  render() {
    return (
      <Fragment>
        <SingleDatePicker
           placeholder={translate(this.props.placeholder)}
           isOutsideRange={() => false}
           showDefaultInputIcon
           inputIconPosition="after"
           firstDayOfWeek={1}
           numberOfMonths={1}
           anchorDirection="right"
           displayFormat={this.localeFormat}
           date={this.state.date} // momentPropTypes.momentObj or null
           onDateChange={(date) => this.setState({ date })} // PropTypes.func.isRequired
           focused={this.state.focused} // PropTypes.bool
           onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
           id={this.props.id} // PropTypes.string.isRequired,
        />
      </Fragment>
    );
  }
}

export default ERPDatePicker;
